import consumer from "./consumer"

// Business case channel is created dynamically on the page with the project ID
// See app/views/sprint_zero/business_cases/edit.html.erb for the subscription logic
console.log("[BusinessCaseChannel] Module loaded, subscriptions will be created on page load");
